import React from 'react';
import { Link } from 'react-router-dom';

const YouMustHaveRegard = ({ cursorVisibility }) => {
  return (
    <Link
      id={cursorVisibility}
      className="You-must-have-regard link none"
      to="/"
    >
      <p>
        You must have regard for my miserable shoes, which could protect your
        naked foot, my salt, which could make your potatoes palatable, and my
        state-carriage, whose possession would appease all of your needs at
        once; you are not allowed to reach out for them.
      </p>
    </Link>
  );
};

export default YouMustHaveRegard;
